__turbopack_context__.v({
  "accent": "HeroCard-module-scss-module__alJtoG__accent",
  "logo": "HeroCard-module-scss-module__alJtoG__logo",
  "tagline": "HeroCard-module-scss-module__alJtoG__tagline",
  "title": "HeroCard-module-scss-module__alJtoG__title",
  "workspaceLogo": "HeroCard-module-scss-module__alJtoG__workspaceLogo",
});
